import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiEndpoints } from 'src/app/app-routes';
import { ErrorService } from 'src/app/services/error/error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private readonly errorService: ErrorService) {}

	intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (req.url.includes(ApiEndpoints.policiesAndConsentsBff.setPublicConsents)) {
			return next.handle(req);
		}
		return next.handle(req).pipe(
			catchError((error: HttpErrorResponse) => {
				this.errorService.handlerError(error);
				return throwError(() => error);
			})
		);
	}
}
